import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Acl } from '@df/core/service/acl';

@Injectable({
    providedIn: 'root'
})
export class DevOnlyGuard implements CanActivate {
    constructor(private acl: Acl) {}

    async canActivate(): Promise<boolean> {
        if (this.acl.isDeveloper || this.acl.check('dev')) {
            return true;
        }
        return false;
    }
}
